import AI from '@images/svg/ai.svg?react';
import ArrowDownIcon from '@images/svg/arrow-down.svg?react';
import ArrowLeftIcon from '@images/svg/arrow-left.svg?react';
import ArrowRightIcon from '@images/svg/arrow-right.svg?react';
import ArrowUpIcon from '@images/svg/arrow-up.svg?react';
import AwardBadgeIcon from '@images/svg/award-badge.svg?react';
import AwardBadgeTwoIcon from '@images/svg/award-badge-2.svg?react';
import BuyerIcon from '@images/svg/buyer.svg?react';
import CalendarIcon from '@images/svg/calendar.svg?react';
import ChatIcon from '@images/svg/chat-alt-2.svg?react';
import CheckCircle from '@images/svg/check-circle.svg?react';
import CheckCircleAlt from '@images/svg/check-circle-alt.svg?react';
import ClockIcon from '@images/svg/clock.svg?react';
import CloseIcon from '@images/svg/close.svg?react';
import CloseCircleIcon from '@images/svg/close-circle.svg?react';
import CommentIcon from '@images/svg/comment.svg?react';
import CompletionBadge from '@images/svg/completion-badge.svg?react';
import DownChevronIcon from '@images/svg/down-chevron.svg?react';
import ExclamationCircleFilledIcon from '@images/svg/exclamation-circle-filled.svg?react';
import ExclamationCircleIcon from '@images/svg/exclamation-circle-icon.svg?react';
import FacebookIcon from '@images/svg/facebook.svg?react';
import FilterIcon from '@images/svg/filter.svg?react';
import GlobeIcon from '@images/svg/globe.svg?react';
import HistoryIcon from '@images/svg/history.svg?react';
import InformationCircleIcon from '@images/svg/information-circle.svg?react';
import InstagramIcon from '@images/svg/instagram.svg?react';
import LinkedinIcon from '@images/svg/linkedin.svg?react';
import LocationMarkerIcon from '@images/svg/location-marker.svg?react';
import PhoneExclamationIcon from '@images/svg/phone-exclamation.svg?react';
import MailIcon from '@images/svg/mail.svg?react';
import PhoneIcon from '@images/svg/phone.svg?react';
import QuotesIcon from '@images/svg/quotes.svg?react';
import ReaLogoBadge from '@images/svg/rea-logo-badge.svg?react';
import SaveUserContactIcon from '@images/svg/save-user-contact.svg?react';
import TagIcon from '@images/svg/tag.svg?react';
import TriangleRight from '@images/svg/triangle-right.svg?react';
import TriangleUp from '@images/svg/triangle-up.svg?react';
import TwitterIcon from '@images/svg/twitter.svg?react';
import VerifiedFilledIcon from '@images/svg/verified-filled.svg?react';
import VerifiedStatusIcon from '@images/svg/verified-status.svg?react';
import YoutubeIcon from '@images/svg/youtube.svg?react';
import PlusIcon from '@images/svg/plus.svg?react';
import InviteIcon from '@images/svg/invite.svg?react';

import Appointment from '@images/svg/business-highlights/appointment.svg?react';
import Availability from '@images/svg/business-highlights/availability.svg?react';
import Boutique from '@images/svg/business-highlights/boutique.svg?react';
import CustomEmail from '@images/svg/business-highlights/custom-email.svg?react';
import CustomHome from '@images/svg/business-highlights/custom-home.svg?react';
import CustomizedSolutions from '@images/svg/business-highlights/customized-solutions.svg?react';
import Discounts from '@images/svg/business-highlights/discounts.svg?react';
import FirstTimeBuyers from '@images/svg/business-highlights/first-time-buyers.svg?react';
import FreeConsultations from '@images/svg/business-highlights/free-consultations.svg?react';
import FreeHomeValutaions from '@images/svg/business-highlights/free-home-valuations.svg?react';
import HomeWalkThroughs from '@images/svg/business-highlights/3d-home-walkthroughs.svg?react';
import LocallyOwned from '@images/svg/business-highlights/locally-owned.svg?react';
import LuxuryHome from '@images/svg/business-highlights/luxury-home.svg?react';
import Realtor from '@images/svg/business-highlights/realtor.svg?react';
import ReferencesAvailable from '@images/svg/business-highlights/references-available.svg?react';
import Relocation from '@images/svg/business-highlights/relocation-specialist.svg?react';
import Satisfaction from '@images/svg/business-highlights/satisfaction-guaranteed.svg?react';
import TourViaVideo from '@images/svg/business-highlights/tour-via-video-chat.svg?react';
import WomenOwned from '@images/svg/business-highlights/women-owned.svg?react';
import YearsInBusiness from '@images/svg/business-highlights/years-in-business.svg?react';

const businessHighlightsIconMap = {
  'Locally owned & operated': LocallyOwned,
  '[LICENSE YEARS] years in business': YearsInBusiness,
  'REALTOR® certified': Realtor,
  'Free home valuations': FreeHomeValutaions,
  'Custom emailed listings': CustomEmail,
  '3D home walkthroughs': HomeWalkThroughs,
  'Luxury home specialist': LuxuryHome,
  'First time buyers': FirstTimeBuyers,
  'Custom home marketing': CustomHome,
  'Tour via video chat': TourViaVideo,
  'Available by appointment': Appointment,
  'Discounts available': Discounts,
  'Relocation specialist': Relocation,
  '24/7 availability': Availability,
  'Satisfaction guaranteed': Satisfaction,
  'Women-owned & operated': WomenOwned,
  'Offers customized solutions': CustomizedSolutions,
  'Free consultations': FreeConsultations,
  'References available': ReferencesAvailable,
  'Boutique brokerage': Boutique,
};

const iconMap = {
  'ai': AI,
  'arrow-down': ArrowDownIcon,
  'arrow-left': ArrowLeftIcon,
  'arrow-right': ArrowRightIcon,
  'arrow-up': ArrowUpIcon,
  'award-badge': AwardBadgeIcon,
  'award-badge-2': AwardBadgeTwoIcon,
  'buyer': BuyerIcon,
  'calendar': CalendarIcon,
  'chat': ChatIcon,
  'check-circle': CheckCircle,
  'check-circle-alt': CheckCircleAlt,
  'clock': ClockIcon,
  'close': CloseIcon,
  'close-circle': CloseCircleIcon,
  'comment': CommentIcon,
  'completion-badge': CompletionBadge,
  'down-chevron': DownChevronIcon,
  'exclamation-circle-filled': ExclamationCircleFilledIcon,
  'exclamation-circle': ExclamationCircleIcon,
  'facebook': FacebookIcon,
  'filter': FilterIcon,
  'globe': GlobeIcon,
  'plus': PlusIcon,
  'history': HistoryIcon,
  'info': InformationCircleIcon,
  'instagram': InstagramIcon,
  'linkedin': LinkedinIcon,
  'location-marker': LocationMarkerIcon,
  'mail': MailIcon,
  'phone': PhoneIcon,
  'phone-exclamation': PhoneExclamationIcon,
  'quotes': QuotesIcon,
  'rea-logo-badge': ReaLogoBadge,
  'save-user-contact': SaveUserContactIcon,
  'tag': TagIcon,
  'triangle-right': TriangleRight,
  'triangle-up': TriangleUp,
  'twitter': TwitterIcon,
  'verified-filled': VerifiedFilledIcon,
  'verified-status': VerifiedStatusIcon,
  'youtube': YoutubeIcon,
  'invite': InviteIcon,
}

export const BusinessIcon = (props) => {
  const { type } = props;

  const IconComponent = businessHighlightsIconMap[type];

  return (
    <IconComponent />
  )
};

export const Icon = (props) => {
  const { type } = props;

  const IconComponent = iconMap[type];

  if (!IconComponent) {
    console.error(`Icon of type [${type}] does not exist`)
  }

  return (
    <IconComponent {...props} />
  )
};

export default Icon;
